//コンテナにoverflow-y:scroll;を指定している事でアンカーリンクが機能しないのを解消する書き方に変更
const scrollAnim = function () {
  let target,
      targetP,
      scrollP,
      position;
  $('.js-btn').on('click', function (e) {
    e.preventDefault();

    target = $(this).attr('href');
    targetP = $(target).position();
    scrollH = $('.l-main__inner').scrollTop();
    position = targetP.top + scrollH;

    $('.l-main__inner').animate({
      scrollTop: position
    }, 400);
  });
};
scrollAnim();
